import { Operation } from 'components/organisms/tasks/filters/operations';
import { SelectFilterOperationType, valueFromString, valueToString } from 'components/organisms/tasks/filters/select';
import { unreachable } from 'utils/unreachable';
import { toType } from './select'; // Right now backend does not support user-{id}/team-{id} format,
// Right now backend does not support user-{id}/team-{id} format,
// so we are sending only id to backend and backend consider this as user id. We will revert this back to its original state once BE fixes
const to = valueToString((x)=>x.join('-'));
const from = valueFromString((x)=>x.split('-'));
const toApiFormat = (filter)=>{
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
            return {
                operation: Operation.IsEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNotEmpty:
            return {
                operation: Operation.IsNotEmpty,
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.Is:
            var _filter_value;
            return {
                operation: Operation.Value,
                value: to((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNot:
            var _filter_value1;
            return {
                operation: Operation.IsNot,
                value: to((_filter_value1 = filter.value) !== null && _filter_value1 !== void 0 ? _filter_value1 : []),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value2;
            return {
                operation: Operation.NoneOf,
                value: to((_filter_value2 = filter.value) !== null && _filter_value2 !== void 0 ? _filter_value2 : []),
                sourceType: filter.field.sourceType
            };
        case SelectFilterOperationType.IsOneOf:
            var _filter_value3;
            return {
                operation: Operation.OneOf,
                value: to((_filter_value3 = filter.value) !== null && _filter_value3 !== void 0 ? _filter_value3 : []),
                sourceType: filter.field.sourceType
            };
        default:
            return unreachable(filter);
    }
};
const parse = ({ value, operation }, field)=>{
    const type = toType(operation);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            return {
                field,
                type,
                value: from(value !== null && value !== void 0 ? value : '')
            };
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
        default:
            return unreachable(`${type} cannot be parsed for ${field.type} field`);
    }
};
export const AssigneeFilter = {
    parse,
    toApiFormat,
    from,
    to
};
